import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function EntranceTest() { 
  useEffect(() => {
    document.title = 'Entrance Test-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li> 
                <li>Admission</li>
                <li>Entrance Test</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Entrance Test</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12"> 
                    <h5>Enterance Test: </h5>
                    <p>Admissions Open for UKG to V for 2025-2026 <br/> Candidates seeking admission to UKG to V are required to appear for an entrance test.</p>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EntranceTest;
